export default __webpack_public_path__ + "static/media/i216sp.018653ab.webp";